import { render, staticRenderFns } from "./SourceDetails.vue?vue&type=template&id=cd05cbcc&scoped=true&"
import script from "./SourceDetails.vue?vue&type=script&lang=js&"
export * from "./SourceDetails.vue?vue&type=script&lang=js&"
import style0 from "./SourceDetails.vue?vue&type=style&index=0&id=cd05cbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd05cbcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VSnackbar})
